import { Card } from 'antd';
import React, { useContext } from 'react';
import { AppContext } from '../../../AppContext';
import Portal from '../../../components/Portal';
import ContactTable from '../components/ContactTable';

const ContactList = () => {
  const {
    state: { pageSize }
  } = useContext(AppContext);
  return (
    <Card className="full-height-card card-body-padding">
      <Portal portalId="header-left-content">
        <span className="portal-header">Contacts</span>
      </Portal>
      {pageSize && <ContactTable />}
    </Card>
  );
};

export default ContactList;
